<template lang="pug">
    #vendors
        v-banner.title-banner(min-height="88")
            .text-h4.font-weight-bold {{this.$t("Menu.__Purchase") + " : " + this.$t("Menu.__VendorInfo")}}
            template(v-slot:actions)
                //- v-menu(open-on-hover offset-y)
                //-     template(v-slot:activator="{ on }")
                //-         v-btn(rounded v-on="on" color="primary")  
                //-             | 匯入
                //-             v-icon(right dark) keyboard_arrow_down
                //-     v-list
                //-         v-list-item(@click="")
                //-             v-list-item-title CSV
                v-btn.ml-6(rounded color="primary" @click="$router.push({name: 'VendorNew'})")  {{$t('Vendors.__AddVendor')}}

        v-container
            //- v-alert(text type="success") 成功創建新的商品/服務 - 商品/服務名稱
            Alert
            ConfirmDialog(v-model="deleteDialog" :title="$t('Vendors.__DeleteVendor')" :message="$t('Vendors.__ConfirmDeleteVendor')" :cancel-text="$t('ActionOption.__Cancel')" :confirm-text="$t('ActionOption.__Delete')" :confirm-action="deleteVendor")

            v-data-table.mt-10.mb-6(:headers="headers" :items="vendors" hide-default-footer :options.sync="options" :loading="loading" :custom-sort="defaultDataSort")
                template(v-slot:item.actions="{item}")
                    v-btn.ma-0(text icon small color="primary" @click="editItem(item)" title="edit")
                        v-icon(small) edit
                    v-btn.ma-0(text icon small color="primary" @click="deleteItem(item)" title="delete" )
                        v-icon(small) delete
            v-row.pagination-row
                v-col.d-flex.align-center.justify-start(cols="6")
                    span.mr-2.d-none.d-md-block {{$t("Table.__ItemsPerPage")}}
                    span
                        v-select.page-select(v-model="options.itemsPerPage" solo dense outlined hide-details :items="perPageItems")
                v-col.d-flex.justify-end(cols="6")
                    v-pagination(v-model="options.page" :length="pageCount")

</template>
<script>
import * as datatableHelper from "@/utils/datatableHelper.js"

export default {
  props: ["alert"],
  mixins: [datatableHelper.mixin],
  data() {
    return {
      perPageItems: [10, 25, 50],
      pageCount: 0,
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      loading: false,

      deleteDialog: false,
      deleteId: 0,

      headers: [
        {
          text: this.$t("ContactInfo.__VendorName"),
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: "Email",
          align: "start",
          sortable: true,
          value: "email"
        },
        {
          text: this.$t("ContactInfo.__Tel"),
          align: "start",
          sortable: true,
          value: "phone"
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: "actions"
        }
      ],
      vendors: [
        // {
        //     id: 1,
        //     name: "John",
        //     email: "john@google.com",
        //     phone: "0912345678"
        // },
        // {
        //     id: 2,
        //     name: "Apple",
        //     email: "apple@google.com",
        //     phone: "0912345676"
        // }
      ],
      actionItems: [
        { title: this.$t("ActionOption.__Edit"), click: this.editItem },
        {
          title: this.$t("Bills.__AddBill"),
          divider: true,
          click: this.newBill
        },
        {
          title: this.$t("ActionOption.__Delete"),
          click: this.deleteItem
        }
      ]
    }
  },
  watch: {
    options: {
      handler() {
        // const { sortBy, sortDesc, page, itemsPerPage } = this.options
        this.getVendors()
      },
      deep: true
    }
  },
  methods: {
    getVendors() {
      var query = this.datatableOptionsToQuery(this.options)
      this.loading = true

      // this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("vendors/getVendors", query)
        .then(
          function(response) {
            this.vendors = response.data == null ? [] : response.data
            this.pageCount = response.paging.totalPages

            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            // this.$store.dispatch("global/stopLoading")
            this.loading = false
          }.bind(this)
        )
    },
    editItem(item) {
      var cid = item.id
      this.$router.push({
        name: "VendorInfo",
        params: {
          cid: cid
        }
      })
    },
    newBill(item) {},
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteId = item.id
    },
    deleteVendor() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("vendors/deleteVendor", this.deleteId)
        .then(
          function(response) {
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
            this.getVendors()
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.deleteDialog = false
    }
  },
  computed: {},
  mounted() {
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {
    this.getVendors()
  }
}
</script>

<style lang="scss">
// @media (min-width: 1264px) {
//     .container {
//         max-width: 100%;
//         padding: 40px;
//     }
// }
</style>
